var _a;
import { useSelector } from "react-redux";
import { isAdminIntegration } from "../../store/statePresenter";
import { getInitialData } from "../../store/stateGetter";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
var DEBUG = ["true", "1"].includes((_a = new URL(window.location.hash.slice(1), window.location.href).searchParams.get("debug")) !== null && _a !== void 0 ? _a : '');
export var useIsUserAccountsEnabled = function () { return useSelector(function (state) {
    var _a, _b, _c;
    if (DEBUG)
        return true;
    if (isAdminIntegration(state))
        return false;
    var initialData = getInitialData(state);
    return !!initialData && !!((_c = (_b = (_a = getResponseManager(initialData)).options) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.enable_user_account);
}); };
export var useEnableUserAccountFloatingPreview = function () { return useSelector(function (state) {
    var _a, _b, _c;
    if (DEBUG)
        return true;
    if (isAdminIntegration(state))
        return false;
    var initialData = getInitialData(state);
    return !!initialData && !!((_c = (_b = (_a = getResponseManager(initialData)).options) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.enable_user_account_preview_button);
}); };
